import styled from "styled-components";
import { Box } from "@mui/material";

export const CreateRequestWrapper = styled.div`
background-color: #fff;
padding: 37px 37px 80px 51px;
border: 1px solid #1B4A83;
border-radius: 5px;
margin-top: 20px;
font-family: 'Noto Sans', sans-serif;
.imageContainer
{
  .noimage
  {
    margin-top:50px;
  }
  .noimagetext
    {
      color: #1B4A83;
      font-family: "Noto Sans", sans-serif;
        font-weight: bold;
        font-size: 16px;
    }
}
.noBorder {
  border: none !important;
}
.createrequestContainer{
.requestForm{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 28px;

      h6 {
        font-size: 16px;
        color: #1b4a83;
        font-weight: 600;
        font-family: "Noto Sans", sans-serif;
      }
      .requestformLeft {
        // display: flex;
        align-items: center;
        gap: 15px;

        span {
          font-size: 14px;
          color: #b4b4b4;
          text-decoration: underline;
          cursor: pointer;
          font-family: "Noto Sans", sans-serif;
        }
        .infoIcon {
          color: black;
          font-size: 14px;
          padding-left: 2px;
        }
        button {
          border-radius: 5px;
          background-color: #b4b4b4;
          text-transform: capitalize;
          font-family: "Noto Sans", sans-serif;
        }
      }
    }
    .ifapplicable {
      font-weight: 200 !important;
    }
    .downloadCountriesUploadTemplateButton {
      border-radius: 5px;
      background-color: transparent !important;
      font-family: "Noto Sans", sans-serif;
    }
    .uploadCountriesButton {
      border-radius: 5px !important;
      background-color: #03715b !important;
      text-transform: capitalize !important;
      font-family: "Noto Sans", sans-serif;
    }
    .replaceFileButton {
      background-color: transparent !important;
      text-transform: capitalize !important;
      font-family: "Noto Sans", sans-serif;
    }
    .uploadedFileName {
      border-style: solid;
      border-color: #b4b4b4 !important;
      border-radius: 5px !important;
      background-color: transparent !important;
      text-transform: capitalize !important;
      font-family: "Noto Sans", sans-serif;
    }

    .viewCountriesButton {
      border-radius: 5px !important;
      background-color: transparent !important;
      text-transform: capitalize !important;
      color: #03715b !important;
      font-family: "Noto Sans", sans-serif;
    }

    .formdataContainer {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 34px 10px 0;
      width: 100%;

      .formdataField {
        width: 25%;
        padding-bottom: 30px;
        text-align: left;
        label {
          font-weight: 700;
          font-size: 16px;
        }
      }

.formInput{
    width: 90%;
    border:0;
    margin-top: 16px;
    font-size:14px;
    .MuiInputBase-input{
        height: 0.2375em;
        background-color: #E4E4E4;
        border-radius: 5px;
        font-weight: bold;
        font-size:14px;
    }
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
        opacity: 1;
        font-family: 'Noto Sans', sans-serif;
        -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
    }
}

}
.buttonAlign {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.secondAccordian {
    margin-top: 25px;
  
    .formdataFieldOne {
      width: 100%;
      text-align: start;
      min-height: 165px;
  
      label {
        font-size: 16px;
        color: #080909;
        font-weight: 700;
        padding-left: 3px;
      }
      svg {
        font-size: 18px;
        margin: -5px 5px;
      }
      .formInputOne {
        margin-top: 16px;
        width: 95%;
        font-size: 14px;
        margin: 16px 0 0 0;
        .MuiInputBase-input {
          height: 0.4375em;
          background-color: #fff;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;

        }
      }
    }
    .formdataFieldTwo {
      width: 50%;
      text-align: start;
      min-height: 175px;
  
      label {
        font-size: 16px;
        color: #080909;
        font-weight: 700;
        padding-left: 3px;
      }
      .infoIcon {
        font-size: 18px;
        margin: -5px 5px;
      }
      .formInputOne {
        margin-top: 16px;
        width: 90%;
        font-size: 14px;
        margin: 16px 0 0 0;
        .MuiInputBase-input {
          height: 0.4375em;
          background-color: #fff;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
          -webkit-text-fill-color: rgb(0 0 0);
        }
      }
    }
    .formdataFiedlTwoTwo {
      width: 75%;
      text-align: start;
      min-height: 175px;
  
      label {
        font-size: 16px;
        color: #080909;
        font-weight: 700;
        padding-left: 3px;
      }
      .infoIcon {
        font-size: 18px;
        margin: -5px 5px;
      }
      .formInputOne {
        margin-top: 16px;
        width: 93%;
        font-size: 14px;
        margin: 16px 0 0 0;
        .MuiInputBase-input {
          height: 0.4375em;
          background-color: #fff;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
          -webkit-text-fill-color: rgb(0 0 0);
        }
      }
    }
    .formatdataFieldFour {
      width: 37%;
      padding: 0px 0;
      min-height: 170px;
      text-align: left;
      svg {
        font-size: 18px;
        margin: -5px 5px;
      }
      label {
        display: block;
        font-size: 16px;
        color: rgb(8, 9, 9);
        font-weight: 700;
        font-size: 16px;
        max-height: 32px;
        padding-left: 3px;
      }
      .formInputOne {
        width: 90%;
        margin-top: 28px;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
    }
    .formatdataFieldFive {
      width: 33%;
      padding: 0px 0;
      min-height: 170px;
      text-align: left;
      svg {
        font-size: 18px;
        margin: -5px 5px;
      }
      label {
        display: block;
        font-size: 16px;
        color: rgb(8, 9, 9);
        font-weight: 700;
        font-size: 16px;
        max-height: 32px;
        padding-left: 3px;
      }
  
      .formInputTwo {
        width: 90%;
        margin-top: 28px;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
      .formInputOne {
        width: 90%;
        margin-top: 16px;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
    }
  
    .formdataFieldThree {
      width: 25%;
      padding: 0px 0;
      min-height: 170px;
      text-align: left;
      svg {
        font-size: 18px;
        margin: -5px 5px;
      }
      .formInputTwo {
        font-weight:400;
        margin-top: 28px;
        width: 90%;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
      .formInputThree {
        font-weight:400;
        margin-top: 28px;
        width: 82%;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
      .formInputTwdoate {
        font-weight:400;
        margin-top: 28px;
        width: 90%;
        font-size: 14px;
        cursor: pointer;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          cursor: pointer;
          font-family: 'Noto Sans', sans-serif;
        }
      }
      .formInputOne {
        margin-top: 16px;
        width:90%;
        font-size: 14px;
        .MuiInputBase-input {
          background-color: #fff;
          height: 0.4375em;
          border-radius: 5px;
          font-family: 'Noto Sans', sans-serif;
        }
      }
  
      .uploadFile {
        display: flex;
      }
      .fileReButton {
        margin-top: 28px;
        margin-right: 30px;
        margin-left: 10px;
        max-height: 40px;
        text-align: center;
        font-weight: 600;
        border-radius: 5px;
        text-transform: none;
        color: #fff;
        width: 40%;
        font-family: 'Noto Sans', sans-serif;
      }
      .fileName {
        margin-top: 28px;
        flex: 1;
        text-decoration: underline;
        color: blue;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        font-family: 'Noto Sans', sans-serif;
      }
      .fileButton {
        margin-top: 28px;
        background-color: #E4E8EE;
        color: #1976d2;
        margin-right: 30px;
        max-height: 40px;
        text-align: center;
        font-weight: 600;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Noto Sans', sans-serif;
        svg {
          font-size: 18px;
          margin: 0px;
        }
      }
      label {
        display: block;
        font-size: 16px;
        color: rgb(8, 9, 9);
        font-weight: 700;
        font-size: 16px;
        max-height: 32px;
        padding-left: 3px;
      }
  
      .inputSelect {
        padding-top: 16px;
        .formInputFour {
          width: 80%;
          font-size: 14px;
          .MuiInputBase-input {
            background-color: #fff;
            height: 0.4375em;
            border-radius: 5px;
            font-family: 'Noto Sans', sans-serif;
          }
        }
        .customDropdown {
          width: 80%;
          margin-top: 12px;
          .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
            height: 0.4375rem;
            min-height: auto;
          }
          .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
            line-height: 0.5;
            font-family: 'Noto Sans', sans-serif;
          }
        }
      }
    }
  }
  
.thirdAccordian{
    margin-top: 25px;
    .thirdAccordianContainer{
        padding: 25px;
        h6 {
          text-align: start;
          color: #080909;
          font-size: 16px;
          font-weight: 600;
        }
        .d-flex {
          flex-wrap: wrap;
          .checkboxInput {
            width: 33%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
              font-family: "Noto Sans", sans-serif;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 75%;
              text-align: justify;
            }
          }
          .selected {
            width: 33%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            .css-j204z7-MuiFormControlLabel-root
              .MuiFormControlLabel-label.Mui-disabled {
              color: #000000;
              font-family: "Noto Sans", sans-serif;
              font-family: "Noto Sans", sans-serif;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 75%;
              text-align: justify;
            }
            .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label {
              font-family: "Noto Sans", sans-serif;
            }
            .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-disabled {
              color: #1b4a83;
              font-family: "Noto Sans", sans-serif;
            }
          }
        }
      }
      .bottomInputButton {
        display: flex;
        width: 94.3%;
        padding-top: 40px;
        text-align: end;
      }
      .accordianBottom {
        // padding: 25px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        -webkit-box-align: center;
        align-items: center;
        .bottomInputButton {
          display: flex;
          width: 94.3%;
          padding-top: 40px;
          text-align: end;
        }
        .bottomInputs {
          max-height: 40px;
          width: 25%;
          margin-top: 70px;
          text-align: start;
          label {
            display: block;
            font-weight: 700;
            font-size: 16px;
          }
          svg {
            font-size: 18px;
          }
          .formInputFour {
            padding-top: 16px;
            font-size: 14px;
            .MuiInputBase-input {
              background-color: #fff;
              height: 0.4375em;
              border-radius: 5px;
              font-family: "Noto Sans", sans-serif;
            }
          }

          .formInputFour-disabled {
            padding-top: 16px;
            font-size: 14px;
            .MuiInputBase-input {
              background-color: #E4E4E4;
              height: 0.4375em;
              border-radius: 5px;
              font-family: "Noto Sans", sans-serif;
            }
          }

          .bottomInputSelect {
            max-height: 40px;
            padding-top: 16px;
            .customDropdown {
              width: 80%;

              .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
                height: 0.4375rem;
                min-height: auto;
              }
              .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
                line-height: 0.5;
                font-family: "Noto Sans", sans-serif;
              }
            }
          }
        }
        .bottomLongInputs {
          max-height: 40px;
          width: 100%;
          margin-top: 90px;
          margin-bottom: 90px;
          text-align: start;
          label {
            display: block;
            font-weight: 700;
            font-size: 16px;
          }
          svg {
            font-size: 18px;
            margin: -5px 5px;
          }
          .formInputFour {
            padding-top: 16px;
            font-size: 14px;
            width: 95%;
            .MuiInputBase-input {
              background-color: #fff;
              height: 0.4375em;
              border-radius: 5px;
              font-family: "Noto Sans", sans-serif;
            }
          }
        }
      }
      button {
        margin-top: 25px;
        text-transform: capitalize;
        margin-left: auto;
        font-family: "Noto Sans", sans-serif;
      }
    }
    .autoComplete {
      button {
        margin-top: 0px;
      }
      svg {
        margin: 0px;
      }
      label {
        font-size: inherit !important;
        font-weight: 500 !important;
        color: black;
      }
    }
  }
  span.error {
    color: #d32f2f;
    line-height: 1;
    font-size: 14px;
    font-weight: 400;
    font-family: "Noto Sans", sans-serif;
  }
  span.red {
    color: #ff0000;
  }
  .errorInput {
    border: 1px solid #ff0000;
    border-radius: 5px;
  }

  .correctInput {
    border: 1px solid black;
    border-radius: 5px;
  }
`;

export const ViewBoxWrapper = styled(Box)`
  margin-top: 52px;
  margin-bottom: 40px;
  .viewTableContainer {
    display:flex;
    flex-direction:column;
    gap:10px;
    .titleDiv{
      display:flex;
      align-items:center;
      gap:10px;
    }
    .d-flex {
      justify-content: space-between;

      h4 {
        color: #1b4a83;
        font-size: 20px;
        font-weight: 600;
        font-family: "Noto Sans", sans-serif;
      }
      button {
        text-transform: capitalize;
        border-radius: 5px;
        font-family: "Noto Sans", sans-serif;
        svg {
          padding-right: 6px;
          font-size: 15px;
        }
      }
      .editBtn {
        button {
          font-family: "Noto Sans", sans-serif;
          background-color: #1b4a83;
        }
      }
    }
  }
  .viewTableContent {
    margin-top: 20px;
    background: #fff;
    thead{
        background-color: rgb(27, 74, 131);
        th{ 
            color: #fff;
            font-size: 14px;
            font-weight: 600;
            padding: 10px 37px;
            ont-family: 'Noto Sans', sans-serif;
        }
        .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
          opacity: 1;
          color: #fff;
      }
       .MuiTableSortLabel-icon {
          opacity: 1;
          color: #fff;
          font-size:20px;
      }
    }
    tbody {
      tr {
        td {
          font-family: "Noto Sans", sans-serif;
          padding: 10px 37px;
        }
      }
    }
  }

  .viewTableContent2 {
    margin-top: 20px;
    thead {
      background-color: rgb(27, 74, 131);
      th {
        color: #fff;
        font-family: "Noto Sans", sans-serif;
        font-size: 14px;
        font-weight: 600;
        padding: 15px;
      }
    }
    tbody {
      tr {
        td {
          font-family: "Noto Sans", sans-serif;
          padding: 15px;
          div {
            width: max-content;
          }
        }
      }
    }
  }
`;

export const CalculationWrapper = styled.div`
  margin-bottom: 130px;
  .calculationContainer {
    h4 {
      font-size: 20px;
      color: #1b4a83;
      font-weight: 600;
      text-align: start;
      padding-bottom: 10px;
      font-family: "Noto Sans", sans-serif;
      span {
        font-weight: 400;
      }
    }
    .calculationContent {
      background-color: #fff;
      border-radius: 0px 0px 5px 5px;
      .d-flex {
        padding: 18px 51px;
        gap: 90px;
        .heading {
          h6 {
            font-family: "Noto Sans", sans-serif;
            font-size: 18px;
            color: #1b4a83;
            text-align: start;
          }
          span {
            color: #2a2725;
            font-size: 18px;
            font-weight: 500;
            font-family: "Noto Sans", sans-serif;
          }
        }
      }
    }
  }
`;
